import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useDispatch, useSelector } from "react-redux";
import SearchFilterBox from "../../Components/SearchFilterBox";
import { toast } from "react-toastify";
import SideModal from "../../Components/SideModal";
import { Save_Owners } from "../../Redux/actions";
import { AddBtn } from "../../Components/Styles/InputStyles";
import AddLOI from "../../Components/PreAgreement/LOI";
import Table from "../../Components/PreAgreement/Table";
import FnFModal from "../../Components/PreAgreement/FnFModal";
import EditLOI from "../../Components/PreAgreement/Edit";
import DeleteLoi from "../../Components/PreAgreement/Delete";

const PreAgreement = () => {
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
    // { label: "Inventory Name", value: 3 },
  ];

  const dispatch = useDispatch();
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState([]);
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [editLoi, setEditLoi] = useState(false);
  const [showAddLoi, setShowAddLoi] = useState(false);
  const [isDeleteOwners, setIsDeleteLoi] = useState(false);
  const [fnfData, setFnfData] = useState(null);
  const [showFnFModal, setShowFnFModal] = useState(false);

  const getFilterType = (type) => {
    switch (type) {
      case 1:
        return "MOBILE";
      case 2:
        return "NAME";
      // case 3:
      //   return "INVENTORY_NAME";
      default:
        return "";
    }
  };

  const fetchFunction = async (params) => {
    const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}`;
    const response = await axios.get(
      `${Config.apiUrl}/owner/loi/list?${query}`,
      {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res?.isSuccess) {
      const list = res?.list;

      const formattedList = Array.isArray(list) ? list : list ? [list] : [];

      setApiData(formattedList);
      dispatch(Save_Owners(formattedList));
    }
  };

  const getError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    isRefetching,
    data,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    getListMutate({ searchQuery, filterType });
  }, []);

  const handleFilterChange = (values) => {
    const type = getFilterType(values.filterType);

    setFilterType(type);
    setSearchQuery(values.searchQuery);

    getListMutate({
      searchQuery: values.searchQuery,
      filterType: type,
    });
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    getListMutate({ searchQuery: "", filterType: "" });
  };

  const handleCloseEditLoi = () => {
    setEditLoi(false);
  };
  const handleCloseAddOwner = () => {
    setShowAddLoi(false);
  };
  //------- Add LOI details -------
  const addLoiFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/owner/loi/add`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const addOwnerSuccess = (data) => {
    setShowAddLoi(false);
    getListMutate({ searchQuery, filterType });
    toast.success(data?.data?.msg || "Success");
  };

  const addOwnerError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addOwnerLoading, mutate: addOwnerMutate } = useMutation(
    addLoiFunction,
    {
      onSuccess: addOwnerSuccess,
      onError: addOwnerError,
    },
  );

  //-------Edit LOI details -------
  const editLoiDetails = async (values) => {
    return await axios.post(`${Config.apiUrl}/owner/loi/edit`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const editLoiSuccess = (data) => {
    setEditLoi(false);
    getListMutate({ searchQuery, filterType });
    toast.success(data?.data?.msg || "Success");
  };

  const editLoiError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editLoiLoading, mutate: editLoiMutate } =
    useMutation(editLoiDetails, {
      onSuccess: editLoiSuccess,
      onError: editLoiError,
    });

  //------- Delete LOI -------
  const deleteLoiFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/owner/loi/delete`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const deleteLoctationSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsDeleteLoi(false);
      getListMutate({ searchQuery, filterType });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const deleteLocationError = (data) => {
    setIsDeleteLoi(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteOwnersLoading, mutate: deleteOwnersMutate } =
    useMutation(deleteLoiFunction, {
      onSuccess: deleteLoctationSuccess,
      onError: deleteLocationError,
    });

  const handleLocationClose = () => {
    setIsDeleteLoi(false);
  };

  const shareLoiFunction = async (loiId) => {
    const response = await axios.get(
      `${Config.apiUrl}/owner/loi/download?loiId=${loiId}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  };

  const shareLoiSuccess = (res) => {
    if (res?.link) {
      setFnfData({
        link: res.link,
        message: res.msg || "",
        sent: false,
      });

      setShowFnFModal(true);
    }

    // toast.success(res?.msg || "LOI fetched successfully");
  };

  const shareLoiError = (error) => {
    toast.error(error?.response?.data?.msg || "Error fetching LOI");
  };

  const { mutate: shareLoiMutate, isLoading: shareLoading } = useMutation(
    shareLoiFunction,
    {
      onSuccess: shareLoiSuccess,
      onError: shareLoiError,
    },
  );
  const handleFnFClose = () => {
    setShowFnFModal(false);
  };

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          LOI (Letter of Intent)
          <Underline />
        </BoxTitle>
        <div className="flex space-x-4 md:ml-auto">
          <AddBtn
            type="button"
            onClick={() => {
              setShowAddLoi(true);
            }}
          >
            {"Add LOI"}
          </AddBtn>
        </div>
      </BoxHead>

      <SideModal
        isOpen={editLoi}
        onClose={handleCloseEditLoi}
        level="base"
      >
        <EditLOI
          handleClose={handleCloseEditLoi}
          selectedData={selectedData}
          editLoiMutate={editLoiMutate}
          editLoiLoading={editLoiLoading}
        />
      </SideModal>
      <SideModal isOpen={showAddLoi} onClose={handleCloseAddOwner} level="base">
        <AddLOI
          handleClose={handleCloseAddOwner}
          selectedData={selectedData}
          addLandlordMutate={addOwnerMutate}
          addLandlordLoading={addOwnerLoading}
        />
      </SideModal>

      <FilterTableWrapper>
        <FilterWrapper className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Left: Total Amount */}
          <div className="flex items-center">
            <Text>
              Total records:{" "}
              <span className="font-semibold">{apiData?.length || 0}</span>
            </Text>
          </div>

          {/* Right: Search / Filters */}
          <div className="flex flex-col gap-3 md:flex-row md:justify-end md:items-center">
            <SearchFilterBox
              options={searchOptions}
              handleFilterChange={handleFilterChange}
              handleClearFilters={handleClearFilters}
            />
          </div>
        </FilterWrapper>

        {isDeleteOwners && (
          <DeleteLoi
            setIsDeleteLoi={setIsDeleteLoi}
            isDeleteOwners={isDeleteOwners}
            deleteOwnersLoading={deleteOwnersLoading}
            deleteOwnersMutate={deleteOwnersMutate}
            selectedData={selectedData}
            handleClose={handleLocationClose}
          />
        )}
        {!error && !isLoading && data && (
          <TableWrapper>
            <Table
              apiData={apiData || []}
              shareLoiMutate={shareLoiMutate}
              shareLoading={shareLoading}
              setShowFnFModal={setShowFnFModal}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              setEditLoi={setEditLoi}
              setIsDeleteLoi={setIsDeleteLoi}
            />
            {(!apiData || apiData.length === 0) && <NotFoundModel />}
          </TableWrapper>
        )}
      </FilterTableWrapper>
      <FnFModal
        isOpen={showFnFModal}
        onClose={handleFnFClose}
        fnfData={fnfData}
        isSending={false}
        isGenerating={shareLoading}
      />

      {error && !isLoading && <NotFoundModel />}
      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const TableWrapper = tw.div`mt-4 bg-white rounded-md`;

const Text = tw.p`text-gray-500 text-sm font-normal`;

export default PreAgreement;
